import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public token: string = '';
  public loggedIn: boolean = false;
  public UserData: LoginResponse;

  constructor(private http: HttpClient) { }

  checkLogin(username: string, password: string): Observable<CheckResponse> {
    let creds = { "username": username, "password": password };
    return this.http.post<CheckResponse>('https://nvr.logisys.hu:8012/login', creds)
  }
  getUserDetails(username: string, password: string): Observable<LoginResponse> {
    let creds = { "username": username, "password": password };
    return this.http.post<LoginResponse>('https://nvr.logisys.hu:8012/login', creds)
  }
}

export interface CheckResponse {
  result: string
}

export interface LoginResponse {
  accessToken: string
  refreshToken: string
  expiresIn: number
}

export interface LoginCreds {
  username: string
  password: string
}

